import { atom } from "jotai";

export const signUpToContinueModalAtom = atom<boolean>(false);
